import classes from "./Service.module.css";
import Image from './Image'
import CommonTitle from "./CommonTitle";
import Layout from "./Layout";
import service from '../assets/service.png';

export default function Service({id}) {

    return (

        <Layout id={id}>
            <CommonTitle title="服务"/>
            <div className={classes["service-content-area"]}>
                <Image width={530} height={436} src={service} alt=""/>
                <div className={classes["service-content"]}>
                    <div className={classes["service-text"]}>
                        <span className={classes["service-text-title"]}>营销服务网络覆盖全国</span>
                        <span className={classes["service-text-title"]}>线上为主，线下为辅，提供全方位安全服务</span>
                    </div>
                    <div className={classes["service-bottom-content"]}>
                        <span className={classes["service-bottom-text"]}><span className={classes["service-spots"]}></span>专业培训</span>
                        <span className={classes["service-bottom-text"]}><span className={classes["service-spots"]}></span>作业安全与风险管控</span>
                        <span className={classes["service-bottom-text"]}><span
                            className={classes["service-spots"]}></span>知识与社交</span>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
